import { NavLink } from "react-router-dom";

import { BrandMark } from "./BrandMark";

type BrandLockupProps = {
  /** When false, renders a static lockup (print surfaces). */
  link?: boolean;
  className?: string;
  markClassName?: string;
  textClassName?: string;
};

export function BrandLockup({
  link = true,
  className = "brandlockup",
  markClassName = "brandlockup__mark",
  textClassName = "brandlockup__text",
}: BrandLockupProps) {
  const content = (
    <>
      <BrandMark className={markClassName} />
      <span className={textClassName}>SecOps</span>
    </>
  );

  if (!link) {
    return (
      <div className={className} aria-label="SecOps">
        {content}
      </div>
    );
  }

  return (
    <NavLink to="/" className={className} aria-label="SecOps Command Center home">
      {content}
    </NavLink>
  );
}
